import {SortDescIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import {LABELS} from '../../constants/labels'
import {getViewsSortOption, VIEWS_SORT_OPTIONS, type ViewsSortValue} from './views-sort-options'

type ViewsSortMenuProps = {
  sort: ViewsSortValue
  onSortChange: (value: ViewsSortValue) => void
}

export function ViewsSortMenu({sort, onSortChange}: ViewsSortMenuProps) {
  const selected = getViewsSortOption(sort)

  return (
    <ActionMenu>
      <ActionMenu.Button variant="invisible" leadingVisual={SortDescIcon}>
        {selected.label}
      </ActionMenu.Button>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single" aria-label={LABELS.views.sortViewsByAriaLabel}>
          <ActionList.GroupHeading>{LABELS.sortBy}</ActionList.GroupHeading>
          {VIEWS_SORT_OPTIONS.map(option => (
            <ActionList.Item
              key={option.value}
              selected={option.value === sort}
              onSelect={() => onSortChange(option.value)}
            >
              {option.label}
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
